/* eslint-disable react-hooks/rules-of-hooks */
import { registerBlockType } from '@wordpress/blocks';
import { useBlockProps, InnerBlocks } from '@wordpress/block-editor';
import { useSelect } from '@wordpress/data';

/**
 * Internal dependencies
 */
import { MOBILE_CONTENT } from '@constants';
import json from './block.json';
import icons from '../icons';
const { name, ...settings } = json;

registerBlockType(name, {
  ...settings,
  icon: icons.desktopContentWrapper,
  edit: (props) => {
    const { context, clientId } = props;
    const activeTab = context['b3rg/activeTab'];
    const enableMobileTab = context['b3rg/enableMobileTab'];
    const blockProps = useBlockProps();
    const innerBlockObj = useSelect(
      (select) => select('core/block-editor').getBlock(clientId).innerBlocks,
    );

    // Allowed inner blocks are decided based on the following array of patterns
    const allowedBlockPatterns = MOBILE_CONTENT.ALLOWED_BLOCK_PATTERNS;
    const allowedBlockTypes = wp.blocks
      .getBlockTypes()
      .map(({ name }) => name)
      .filter((blockName) =>
        allowedBlockPatterns.some((v) => blockName.includes(v)),
      );

    // Limits the number of blocks to be used as top-level inner blocks to 1
    const appenderToUse = () =>
      innerBlockObj.length < 1 ? <InnerBlocks.ButtonBlockAppender /> : false;

    return (
      <div {...blockProps}>
        {activeTab === 'desktop' ||
        (!enableMobileTab && activeTab === 'mobile') ? (
          <InnerBlocks
            templateLock={false}
            renderAppender={() => appenderToUse()}
            allowedBlocks={allowedBlockTypes}
          />
        ) : null}
      </div>
    );
  },

  save: () => {
    return <InnerBlocks.Content />;
  },
});
